import { Provider } from '@angular/core';

import { PdfUseCasesImpl } from '@app/domain/use-cases/ptrab/pdf/pdf.use-cases';
import { PDF_USE_CASES } from '@app/domain/use-cases/ptrab/pdf/pdf.use-cases.contract';

export const pdfUseCasesProvider: Provider = {
  provide: PDF_USE_CASES,
  useClass: PdfUseCasesImpl
};
